export default __webpack_public_path__ + "static/media/Web_03-01.e7fdf8de.png";